<template>
    <div class="main-section">
        <img :src="require('@/assets/images/wm-promotion/main-section/faq.png')" alt="" />
    </div>
</template>

<script>
export default {
    name: 'Wm1',
}
</script>

<style scoped lang="scss">
.main-section {
    padding-bottom: 50px;
}
</style>
